export default "__VITE_ASSET__c0e67ec9__"